import React from 'react'
import BaseIcon from 'react-icon-base'

import { EColors } from 'app/constants/colors'

interface IAvailableDomainProps {
  circleborder?: string
  checkcolor?: string
  background?: string
  width?: string
  height?: string
  viewBox?: string
  className?: string
}

const AvailableDomain: React.FC<IAvailableDomainProps> = props => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill={props.background} fillRule="evenodd" opacity=".9">
      <circle cx="8" cy="8" r="7.5" stroke={props.circleborder} />
      <path
        fill={props.checkcolor}
        d="M6.008 11.296a.74.74 0 0 0 .873-.13l4.902-4.902a.74.74 0 0 0-1.047-1.047L6.329 9.623 5.264 8.558a.74.74 0 0 0-1.047 1.048l1.517 1.516c.08.08.174.138.274.174z"
      />
    </g>
  </BaseIcon>
)

AvailableDomain.defaultProps = {
  circleborder: EColors.BLUE,
  checkcolor: EColors.BLUE,
  background: EColors.WHITE,
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
}

export default AvailableDomain
